export default function pureHTML(html) {
  return <div>
      dangerouslySetInnerHTML={{__html: html}}
  </div>;
}